import React, { useState, useEffect } from "react";
import { Dropdown, TextInput, Image } from "hesus-ui-kit";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import errorIcon from "@icons/ic-error.svg";
import {
  renderPriceWithCurrencyWithoutUnit,
  addSpace,
  updateUnitTranslation,
} from "@utils/utils";
import { APIErrorMEssage } from "../../AddEditSellingPrice.styled";
import AddressSearch from "../../../../../components/AddressSearch";
import SolutionListing from "../SolutionListing";
import {
  Title,
  ServiceTitleConatiner,
  MarginContainer,
  GridRow,
  SellingPriceContainer,
  MarginLabel,
  MarginValue,
  PriceContainer,
  PricePerUnit,
  ErrorDiv,
} from "./ServiceTypeCondition.styled";

import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
  RequiredMessage,
} from "@utils/extra-style";

const ServiceTypeCondition = (props) => {
  const {
    t,
    onSellingPriceSolutionChange,
    serviceInfo,
    isJobsite,
    isEditMode,
    isDisabled,
    onChange,
    countryId,
    products,
    transportList,
    productsAPIError,
    isTransportAPIError,
    currencyPosition,
    currency,
    enquiryId,
    catalogServiceIdSolutionApi,
    countryNeedSolution,
    exchangeRate,
    currencyId,
  } = props;

  const [columnNumber, setColumnNumber] = useState(3);

  const generalParams = useGetGeneralParameters();

  const { unitList, countryList } = generalParams;

  useEffect(() => {
    if (
      (serviceInfo.hesusServiceInfo.needTransport &&
        serviceInfo.hesusServiceInfo.needProduct) ||
      serviceInfo.hesusCatalogServiceCombination !== null
    ) {
      setColumnNumber(4);
    }
  }, []);

  const getCountryName = (selectedCountryId) => {
    if (selectedCountryId) {
      const isCountryPresent = countryList.find(
        ({ id }) => id === selectedCountryId
      );
      if (isCountryPresent) {
        return isCountryPresent.label;
      }
    }
    return "";
  };

  const checkDisableProductStatus = (needProduct, combinationId) => {
    if (isDisabled) return isDisabled;
    if (combinationId) {
      if (!isDisabled) {
        if (needProduct) {
          return false;
        }
        return true;
      }
    }
    return isDisabled;
  };

  const checkDisableTransportStatus = (needtransport, combinationId) => {
    if (isDisabled) return isDisabled;
    if (combinationId) {
      if (!isDisabled) {
        if (!needtransport || needtransport === 0) {
          return false;
        }
        return true;
      }
    }
    return isDisabled;
  };

  return (
    <>
      <SellingPriceContainer>
        <ServiceTitleConatiner>
          <Title>{t(serviceInfo.hesusServiceInfo.name)}</Title>
        </ServiceTitleConatiner>
        <GridRow
          column={columnNumber === 3 ? "1fr 1fr 1fr" : "1fr 1fr 1fr 1fr"}
        >
          <TextInput
            type="text"
            label={t("QUANTITY")}
            name={serviceInfo.serviceField.quantity.name}
            id={serviceInfo.serviceField.quantity.name}
            isFloat
            placeholder={t("QUANTITY")}
            value={String(serviceInfo.serviceField.quantity.value)}
            disabled={isDisabled}
            required
            errorStyles={{ "font-style": "italic" }}
            onChange={onChange}
            labelStyles={
              serviceInfo.serviceField.quantity.error !== ""
                ? labelStylesError
                : labelStyles
            }
            inputStyles={
              serviceInfo.serviceField.quantity.error !== ""
                ? inputStylesError
                : inputStyles
            }
            containerStyles={{ marginTop: "21px" }}
            error={serviceInfo.serviceField.quantity.error}
          />
          <Dropdown
            label={t("UNIT")}
            name={serviceInfo.serviceField.unit.name}
            id={serviceInfo.serviceField.unit.name}
            value={String(serviceInfo.serviceField.unit.value)}
            defaultOption={t("UNIT")}
            options={updateUnitTranslation(unitList, t)}
            required
            disabled={isDisabled}
            onChange={onChange}
            labelStyles={
              serviceInfo.serviceField.unit.error !== ""
                ? labelStylesError
                : labelStyles
            }
            inputStyles={
              serviceInfo.serviceField.unit.error !== ""
                ? inputStylesError
                : inputStyles
            }
            containerStyles={{ marginBottom: "7px" }}
            error={serviceInfo.serviceField.unit.error}
          />
          {!serviceInfo.hesusServiceInfo.needSolution && (
            <TextInput
              type="text"
              label={t("SELLING_PRICE_ITEM_PURCHASE_PRICE")}
              name={serviceInfo.serviceField.purchasePrice.name}
              id={serviceInfo.serviceField.purchasePrice.name}
              isFloat
              placeholder={t("SELLING_PRICE_ITEM_PURCHASE_PRICE")}
              value={String(serviceInfo.serviceField.purchasePrice.value)}
              // disabled={isDisabled}
              required
              errorStyles={{ "font-style": "italic" }}
              onChange={onChange}
              labelStyles={
                serviceInfo.serviceField.purchasePrice.error !== ""
                  ? labelStylesError
                  : labelStyles
              }
              inputStyles={
                serviceInfo.serviceField.purchasePrice.error !== ""
                  ? inputStylesError
                  : inputStyles
              }
              containerStyles={{ marginTop: "21px" }}
              error={serviceInfo.serviceField.purchasePrice.error}
            />
          )}
          {(serviceInfo.hesusServiceInfo.needProduct ||
            serviceInfo.hesusCatalogServiceCombination !== null) && (
            <>
              <Dropdown
                label={t("PRODUCT")}
                name={serviceInfo.serviceField.product.name}
                id={serviceInfo.serviceField.product.name}
                value={serviceInfo.serviceField.product.value}
                defaultOption={t("PRODUCT")}
                options={products}
                required
                disabled={checkDisableProductStatus(
                  serviceInfo.hesusServiceInfo.needProduct,
                  serviceInfo.hesusCatalogServiceCombination
                )}
                onChange={onChange}
                labelStyles={
                  serviceInfo.serviceField.product.error !== ""
                    ? labelStylesError
                    : labelStyles
                }
                inputStyles={
                  serviceInfo.serviceField.product.error !== ""
                    ? inputStylesError
                    : inputStyles
                }
                containerStyles={{ marginBottom: "7px" }}
                error={serviceInfo.serviceField.product.error}
              />
              {productsAPIError !== "" && (
                <APIErrorMEssage>{productsAPIError}</APIErrorMEssage>
              )}
            </>
          )}
          {(serviceInfo.hesusServiceInfo.needTransport ||
            serviceInfo.hesusCatalogServiceCombination !== null) && (
            <>
              <Dropdown
                label={t("TRANSPORT_TYPE")}
                name={serviceInfo.serviceField.transport.name}
                id={serviceInfo.serviceField.transport.name}
                value={serviceInfo.serviceField.transport.value}
                defaultOption={t("TRANSPORT_TYPE")}
                options={transportList}
                required
                disabled={checkDisableTransportStatus(
                  serviceInfo.hesusServiceInfo.needTransport,
                  serviceInfo.hesusCatalogServiceCombination
                )}
                onChange={onChange}
                labelStyles={
                  serviceInfo.serviceField.transport.error !== ""
                    ? labelStylesError
                    : labelStyles
                }
                inputStyles={
                  serviceInfo.serviceField.transport.error !== ""
                    ? inputStylesError
                    : inputStyles
                }
                containerStyles={{ marginBottom: "7px" }}
                error={serviceInfo.serviceField.transport.error}
              />
              {isTransportAPIError !== "" && (
                <APIErrorMEssage>{isTransportAPIError}</APIErrorMEssage>
              )}
            </>
          )}
        </GridRow>

        {serviceInfo.hesusServiceInfo.needDestination && (
          <GridRow column="1fr">
            <AddressSearch
              isFloat
              title="SELLING_PRICE_DESTINATION"
              className="serviceTypeAddress"
              countryId={countryId}
              name={serviceInfo.serviceField.destination.name}
              language={localStorage.getItem("locale")}
              onAddressSelect={(data) =>
                onChange(data, serviceInfo.serviceField.destination.name)
              }
              defaultAddress={
                isEditMode
                  ? serviceInfo.serviceField.destination.value?.street +
                    " " +
                    serviceInfo.serviceField.destination.value?.postalCode +
                    " " +
                    serviceInfo.serviceField.destination.value?.city +
                    " " +
                    (serviceInfo.serviceField.destination.value?.country
                      ? getCountryName(
                          serviceInfo.serviceField.destination.value.country
                        )
                      : "")
                  : ""
              }
              error={serviceInfo.serviceField.destination.error}
            />
          </GridRow>
        )}
        {serviceInfo.hesusServiceInfo.needSolution && (
          <GridRow>
            <SolutionListing
              isEditMode={isEditMode}
              isDisabled={isDisabled}
              serviceData={serviceInfo}
              onSellingPriceSolutionChange={onSellingPriceSolutionChange}
              hesusCatalogServiceId={serviceInfo.hesusCatalogServiceId}
              hesusServiceId={serviceInfo.hesusServiceInfo.id}
              catalogServiceIdSolutionApi={catalogServiceIdSolutionApi}
              currency={currency}
              currencyPosition={currencyPosition}
              onChange={onChange}
              countryNeedSolution={countryNeedSolution}
              exchangeRate={exchangeRate}
              currencyId={currencyId}
            />
          </GridRow>
        )}
        {serviceInfo.serviceField.purchasePrice.error && (
          <GridRow>
            <ErrorDiv>
              <RequiredMessage maxWidth="auto">
                <Image
                  src={errorIcon}
                  alt="warning"
                  styles={{ width: "18px", marginRight: "10px" }}
                />{" "}
                {serviceInfo.serviceField.purchasePrice.error}
              </RequiredMessage>
            </ErrorDiv>
          </GridRow>
        )}

        <GridRow column="1fr 1fr 1fr" marginTop="21px">
          <PriceContainer>
            <TextInput
              type="text"
              label={t("SELLING_PRICE_ITEM_PRICE")}
              name={serviceInfo.serviceField.unitPrice.name}
              id={serviceInfo.serviceField.unitPrice.name}
              isFloat
              placeholder={t("SELLING_PRICE_ITEM_PRICE")}
              value={String(serviceInfo.serviceField.unitPrice.value)}
              disabled={isDisabled}
              required
              errorStyles={{ "font-style": "italic" }}
              onChange={onChange}
              labelStyles={
                serviceInfo.serviceField.unitPrice.error !== ""
                  ? labelStylesError
                  : labelStyles
              }
              inputStyles={
                serviceInfo.serviceField.unitPrice.error !== ""
                  ? inputStylesError
                  : inputStyles
              }
              containerStyles={{ marginTop: "21px" }}
              error={serviceInfo.serviceField.unitPrice.error}
            />
            <PricePerUnit>
              {serviceInfo.serviceField.unit.value
                ? `${currency}/${t(serviceInfo.serviceField.unit.value)}`
                : ""}
            </PricePerUnit>
          </PriceContainer>
          <MarginContainer>
            <MarginLabel>{t("SELLING_PRICE_ITEM_TOTAL")}</MarginLabel>
            <MarginValue>
              {serviceInfo.serviceField.unit.value &&
              serviceInfo.serviceField.totalPrice.value
                ? renderPriceWithCurrencyWithoutUnit(
                    addSpace(serviceInfo.serviceField.totalPrice.value),
                    currency,
                    currencyPosition
                  )
                : ""}
            </MarginValue>
          </MarginContainer>
          <MarginContainer>
            <MarginLabel>{t("SELLING_PRICE_ITEM_MARGIN")}</MarginLabel>
            {serviceInfo.serviceField.marginRate.value !== null && (
              <MarginValue
                color={
                  serviceInfo.serviceField.marginRate.value < 0
                    ? "#E83F1E"
                    : "green"
                }
              >
                {serviceInfo.serviceField.marginRate.value} %
              </MarginValue>
            )}
            {serviceInfo.serviceField.marginRate.value === null && (
              <MarginValue color="#E83F1E"> ?</MarginValue>
            )}
          </MarginContainer>
        </GridRow>
        <GridRow>
          <TextInput
            type="textarea"
            label={t("SELLING_PRICE_COMMENT")}
            name={serviceInfo.serviceField.comment.name}
            id={serviceInfo.serviceField.comment.name}
            isFloat
            placeholder={t("SELLING_PRICE_COMMENT")}
            value={String(serviceInfo.serviceField.comment.value)}
            disabled={isDisabled}
            errorStyles={{ "font-style": "italic" }}
            onChange={onChange}
            labelStyles={
              serviceInfo.serviceField.comment.error !== ""
                ? labelStylesError
                : labelStyles
            }
            inputStyles={
              serviceInfo.serviceField.comment.error !== ""
                ? inputStylesError
                : inputStyles
            }
            containerStyles={{ marginTop: "21px" }}
            error={serviceInfo.serviceField.comment.error}
          />
        </GridRow>
      </SellingPriceContainer>
    </>
  );
};

ServiceTypeCondition.propTypes = {
  isJobsite: PropTypes.bool,
  isEditMode: PropTypes.bool,
  isDisabled: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

ServiceTypeCondition.defaultProps = {
  isJobsite: false,
  isDisabled: null,
  isEditMode: null,
};

export default withTranslation()(ServiceTypeCondition);
